// tourSteps.js
// Conteúdo do tour guiado do sistema. Editar aqui não exige mexer no TourModal.
import {
  FaHandsHelping, FaUserPlus, FaCarSide, FaFileInvoiceDollar,
  FaLink, FaClipboardList, FaCar, FaMoneyBillWave, FaCog,
  FaFileSignature, FaFileContract, FaFileAlt, FaRegCalendarAlt, FaUpload
} from 'react-icons/fa';
import {
  ExemploCadastroCliente, ExemploVeiculoDocumento, ExemploImportarCrlv, ExemploServicosHonorarios,
  ExemploVincularPassivo, ExemploCriarOS, ExemploVincularVeiculo,
  ExemploProcuracao, ExemploContratos, ExemploDocumentosComplementares, ExemploAgenda,
  ExemploRelatorioCaixa, ExemploConfiguracoes
} from './TourExemplos';

const tourSteps = [
  {
    icone: FaHandsHelping,
    titulo: 'Bem-vindo ao sistema',
    descricao: 'Este tour rápido mostra os principais fluxos do dia a dia. Use Avançar/Voltar para navegar, ou Sair a qualquer momento. Você pode rever este tour quando quiser em Configurações.',
    Exemplo: null
  },
  {
    icone: FaUserPlus,
    titulo: 'Cadastro de Clientes',
    descricao: 'Pesquise por nome ou CPF/CNPJ antes de cadastrar — se o cliente já existir, você edita em vez de duplicar.',
    Exemplo: ExemploCadastroCliente
  },
  {
    icone: FaCarSide,
    titulo: 'Veículos e upload do CRLV',
    descricao: 'Cada veículo tem seu próprio botão de documentos — é ali que você sobe o PDF do CRLV. Esse botão é diferente do de documentos do cliente, que fica no topo do card.',
    Exemplo: ExemploVeiculoDocumento
  },
  {
    icone: FaUpload,
    titulo: 'Novo: Importar CRLV-e direto do menu',
    descricao: 'Um atalho para não precisar abrir cliente por cliente: em "Importar CRLV-e", no menu da tela inicial, escolha vários CRLV-e (PDF ou foto) de uma vez e o sistema faz o resto — acha o cliente pelo CPF/CNPJ do proprietário (ou cadastra), cadastra ou completa o veículo e guarda o CRLV nos documentos dele. Se algum dado for diferente do cadastro, ele pergunta campo a campo; placa que está em outro cliente fica para você confirmar a transferência no fim. O upload pelo veículo, do passo anterior, continua funcionando normalmente.',
    Exemplo: ExemploImportarCrlv
  },
  {
    icone: FaFileInvoiceDollar,
    titulo: 'Serviços de Honorários',
    descricao: 'Um serviço sem valor definido aparece como "Aguardando cadastro" — edite e informe o valor antes de usá-lo. Marcar como inativo tira o serviço da lista de seleção sem apagar o histórico.',
    Exemplo: ExemploServicosHonorarios
  },
  {
    icone: FaLink,
    titulo: 'Vincular Serviços Passivos',
    descricao: 'Clique no ícone de elo de um serviço de honorário para abrir a lista de passivos (repasses como IPVA, licenciamento, multas) e marcar quais se aplicam.',
    Exemplo: ExemploVincularPassivo
  },
  {
    icone: FaClipboardList,
    titulo: 'Criar uma Ordem de Serviço',
    descricao: 'Selecione o cliente e escolha o tipo de atendimento: relacionado a veículo ou não relacionado a veículo.',
    Exemplo: ExemploCriarOS
  },
  {
    icone: FaCar,
    titulo: 'Vincular veículo na OS',
    descricao: 'Cada item aceita três formas de identificação: veículo cadastrado, ou placa/chassi manual — útil quando o veículo ainda não está cadastrado (ex: emissão de ATPV-e).',
    Exemplo: ExemploVincularVeiculo
  },
  {
    icone: FaFileSignature,
    titulo: 'Procuração de Veículo',
    descricao: 'Escolha o modelo (em causa própria, aquisição, etc.), preencha outorgante, veículo e outorgado(s) — o documento gerado fica editável na tela antes de imprimir ou salvar em PDF.',
    Exemplo: ExemploProcuracao
  },
  {
    icone: FaFileContract,
    titulo: 'Contratos',
    descricao: 'Compra e venda, comodato ou locação. O sistema avisa quando um dado digitado é diferente do que já está no cadastro, e você pode salvar essa atualização de volta com um clique.',
    Exemplo: ExemploContratos
  },
  {
    icone: FaFileAlt,
    titulo: 'Documentos Complementares',
    descricao: 'Catálogo de outros documentos (declarações, autorizações) com busca por palavra-chave. O fluxo de preenchimento e geração é o mesmo da Procuração.',
    Exemplo: ExemploDocumentosComplementares
  },
  {
    icone: FaRegCalendarAlt,
    titulo: 'Agenda',
    descricao: 'Calendário de lembretes compartilhado por toda a empresa. Cada dia mostra a quantidade de lembretes — clique num dia pra ver ou criar um novo.',
    Exemplo: ExemploAgenda
  },
  {
    icone: FaMoneyBillWave,
    titulo: 'Relatório de Caixa',
    descricao: 'Mostra o fechamento por período, com o total de ordens de serviço e valores recebidos.',
    Exemplo: ExemploRelatorioCaixa
  },
  {
    icone: FaCog,
    titulo: 'Configurações',
    descricao: 'Gerencie backup de dados e links úteis do painel — e reabra este tour sempre que precisar.',
    Exemplo: ExemploConfiguracoes
  }
];

export default tourSteps;
